import React from 'react';
import styled from 'styled-components';
import MoreMenu from '../MoreMenu';
import { toRgba } from '../theme/colors';
import theme from '../theme';

const CardListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const Card = styled.div`
  position: relative;
  background: ${(props) => props.theme.colors.NEU_0};
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px ${toRgba(theme.colors.NEU_999, 0.1)};
  ${(props) =>
    props.$hasClick === 'true' &&
    `
    cursor: pointer;
    &:active {
      background-color: ${props.theme.colors.NEU_50};
    }
  `}
`;

const CardTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.TEXT_FONT}, sans-serif;
  font-size: ${(props) => props.theme.fontSizes.medium};
  font-weight: 500;
  color: ${(props) => props.theme.colors.NEU_PRIMARY};
  padding-right: 32px;
  margin-bottom: 8px;
`;

const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  font-family: ${(props) => props.theme.fonts.TEXT_FONT}, sans-serif;
  font-size: ${(props) => props.theme.fontSizes.xSmall};
  color: ${(props) => props.theme.colors.NEU_PRIMARY};
`;

const CardLabel = styled.span`
  text-transform: uppercase;
  font-weight: 300;
  color: ${(props) => props.theme.colors.NEU_600};
`;

const CardActions = styled.div`
  position: absolute;
  top: 8px;
  right: 4px;
`;

const ListCardView = ({ data, tableInfo, tableName, alignLeft = 0, onItemClick }) => {
  return (
    <CardListWrapper>
      {data?.map((item) => {
        const menuCol = tableInfo.find((col) => !!col.menuOptions);
        const menuOptions = menuCol?.menuOptions(item);
        return (
          <Card key={`${tableName}-card-${item.id}`} onClick={(e) => onItemClick && onItemClick(e, item)} $hasClick={(!!onItemClick).toString()}>
            {menuOptions?.length > 0 && (
              <CardActions>
                <MoreMenu item={item} options={menuOptions} />
              </CardActions>
            )}
            {tableInfo.map((col, index) => {
              if (col.menuOptions) return null;
              const value = col.data ? col.data(item) : '-';
              if (index === alignLeft) {
                return <CardTitle key={`${tableName}-card-title-${item.id}`}>{value}</CardTitle>;
              }
              if (!col.label) return null;
              return (
                <CardRow key={`${tableName}-card-${col.label}-${item.id}`}>
                  <CardLabel>{col.label}</CardLabel>
                  <div>{value}</div>
                </CardRow>
              );
            })}
          </Card>
        );
      })}
    </CardListWrapper>
  );
};

export default ListCardView;
